
import React from "react";
import { toast } from "sonner";
import { AuthContext } from "../AuthContext";
import { useAuthState } from "./useAuthState";
import { useAuthInitialization } from "./useAuthInitialization";

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const {
    session,
    user,
    loading,
    isAdmin,
    isSalesAssistant,
    assignedBases,
    authInitialized, // Key flag for initialization
    handleCheckIsAdmin,
    handleCheckIsSalesAssistant,
    handleRefreshAssignedBases,
    handleSignOut,
    checkAndUpdateUserRoles,
    // State setters
    setSession,
    setUser,
    setLoading,
    setAuthInitialized
  } = useAuthState();

  // Initialize authentication
  useAuthInitialization({
    setSession,
    setUser,
    setLoading,
    setAuthInitialized,
    checkAndUpdateUserRoles
  });

  const signOut = async () => {
    try {
      await handleSignOut();
      toast.success("Logged out successfully");
      return Promise.resolve();
    } catch (error) {
      toast.error("Failed to sign out");
      return Promise.reject(error);
    }
  };

  const value = {
    session,
    user,
    loading,
    signOut,
    isAdmin,
    isSalesAssistant,
    checkIsAdmin: handleCheckIsAdmin,
    checkIsSalesAssistant: handleCheckIsSalesAssistant,
    assignedBases,
    refreshAssignedBases: handleRefreshAssignedBases
  };

  console.log("AuthContext current values:", { 
    hasUser: !!user, 
    hasSession: !!session, 
    isAdmin, 
    isSalesAssistant, 
    assignedBases,
    loading,
    initialized: authInitialized
  });

  // If authentication is not yet initialized, return null or a loading indicator.
  // This prevents children from rendering and potentially causing hook order issues
  // while the auth provider's internal hooks are still settling.
  if (!authInitialized) {
    // You can replace null with a global loading spinner if you have one
    // e.g., return <GlobalAppSpinner />;
    return null; 
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

